import { render } from "./Breadcrumb.vue?vue&type=template&id=a4f38548"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "/Users/frknalck/Desktop/MySite/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__